import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import { handleAnalytics, Events } from '@foxcorp/delta-web-analytics';
import Header from '../Header';
import Style from './Perks.module.scss';

const Perks = ({
  headerProps = {},
  language = {},
  onLoginClick = noop,
  onSignupClick = noop,
  perks = [],
  renderPerkImage = noop,
  toggleShowPerks = noop,
  toggleSignin = noop,
  toggleSignup = noop,
  utagAccountSource,
}) => {
  const dialogElement = useRef(null);
  const {
    profileCreate_header: createProfileText,
    profilePerks_header: headerText,
    profileCreate_signInText: profileExistText,
    profileFavoritesUpsell_signInButton: signInText,
  } = language || {};

  useEffect(() => {
    handleAnalytics({
      event: Events.PROFILE_PROMPT,
      payload: {
        page_start_source: utagAccountSource,
      },
    });
    if (dialogElement) dialogElement.current.focus();
  }, [dialogElement]);

  return (
    <main className={Style.Perks}>
      <Header {...headerProps} />
      <div className={Style.PerksContainer} ref={dialogElement} role="link" tabIndex="0">
        <h1>{headerText}</h1>
        <div className={Style.perksWrap}>
          {perks.map(perk => {
            const { icon, text } = perk;
            return (
              <div className={Style.perkContainer} key={`perk-${text}`}>
                <div className={Style.imageContainer}>
                  {renderPerkImage({
                    alt: text,
                    className: 'perkIcon',
                    src: icon,
                  })}
                </div>
                <div className={Style.perkText}>{text}</div>
              </div>
            );
          })}
        </div>
        <div className={Style.buttonWrap}>
          <button
            className={Style.btnPrimary}
            onClick={() => {
              toggleShowPerks();
              toggleSignup();
              if (onSignupClick) onSignupClick();
            }}
          >
            {createProfileText}
          </button>
          <div
            className={Style.signInText}
            onClick={() => {
              toggleShowPerks();
              toggleSignin();
              if (onLoginClick) onLoginClick();
            }}
          >
            {`${profileExistText} ${signInText}`}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Perks;

Perks.propTypes = {
  headerProps: PropTypes.shape({}).isRequired,
  hollow: PropTypes.string,
  language: PropTypes.shape({
    profilePerks_header: PropTypes.string,
    profilePerks_SignUpButton: PropTypes.string,
    profilePerks_SignInButton: PropTypes.string,
  }).isRequired,
  onLoginClick: PropTypes.func.isRequired,
  onSignupClick: PropTypes.func.isRequired,
  perks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  renderPerkImage: PropTypes.func.isRequired,
  toggleShowPerks: PropTypes.func.isRequired,
  toggleSignup: PropTypes.func.isRequired,
  toggleSignin: PropTypes.func.isRequired,
  utagAccountSource: PropTypes.string.isRequired,
};
